import { render } from "./SelectMenu.vue?vue&type=template&id=8da211cc&scoped=true&ts=true"
import script from "./SelectMenu.vue?vue&type=script&lang=ts"
export * from "./SelectMenu.vue?vue&type=script&lang=ts"

import "./SelectMenu.vue?vue&type=style&index=0&id=8da211cc&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da211cc"]])

export default __exports__